export enum ColorEnum {
  primary = 'primary',
  primaryLight = 'primaryLight',
  transparent = 'transparent',
}

export type Color = keyof typeof ColorEnum;
